var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChipBackground = function SvgChipBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3a3 3 0 0 1 3-3h21.5a3 3 0 0 1 2.4 1.2l4.5 6A3 3 0 0 1 32 9v9a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3Z",
    fill: "#F1F2F2"
  })));
};
export default SvgChipBackground;